
import { RepositoryCard } from "@/components/repositories/RepositoryCard";
import { RepositoryIntro } from "@/components/repositories/RepositoryIntro";
import { repositories } from "@/data/repositories";
import { Link } from "react-router-dom";

export const RepositoriesSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-background to-card">
      <div className="container-custom">
        <div className="max-w-7xl mx-auto">
          <RepositoryIntro />
          
          <div className="grid gap-8 relative">
            <div className="absolute inset-0 bg-[radial-gradient(1000px_600px_at_top_center,theme(colors.brand.orange/10),transparent)] dark:bg-[radial-gradient(1000px_600px_at_top_center,theme(colors.brand.orange/5),transparent)] -z-10" />
            {repositories.map((repo, index) => (
              <RepositoryCard
                key={index}
                name={repo.name}
                manager={repo.manager}
                icon={repo.icon}
                role={repo.role}
                usages={repo.usages}
              />
            ))}
          </div>

          <div className="max-w-4xl mx-auto text-center mt-16">
            <p className="text-lg text-muted-foreground mb-8">
              Essayez notre moteur de recherche et découvrez de nouvelles opportunités !
            </p>

            <a 
              href="/search" 
              className="inline-flex items-center px-8 py-4 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl text-lg"
            >
              Accédez au moteur de recherche dès maintenant
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
